import { createElement, createTextElement } from "./util";

export interface ButtonContent {
  label: string;
  icon?: string;
}

export function getButtonContent(
  element: HTMLButtonElement,
): ButtonContent | null {
  const spans = element.getElementsByTagName("span");
  const icons = element.getElementsByTagName("i");

  if (spans.length) {
    return {
      label: spans[0].innerText,
      icon: icons.length ? icons[0].className : undefined,
    };
  }

  return null;
}

export function applyButtonContent(
  element: HTMLButtonElement,
  content: ButtonContent,
) {
  const children: Node[] = [createTextElement(content.label)];

  if (content.icon) {
    children.unshift(document.createTextNode("\u00A0"));
    children.unshift(createElement("i", content.icon));
  }

  element.replaceChildren(...children);
}

export function setButtonLoadingState(
  element: HTMLButtonElement,
  label = "Loading...",
) {
  const buttonContent = getButtonContent(element);
  if (buttonContent) {
    applyButtonContent(element, {
      label,
      icon: "fa-sharp-duotone fa-regular fa-gear-complex fa-spin fa-fw",
    });
  }

  element.disabled = true;

  return () => {
    if (buttonContent) {
      applyButtonContent(element, buttonContent);
      element.disabled = false;
    }
  };
}
